import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Plus, X } from "lucide-react";
import { Button } from "../../components/ui/button";
import { Input } from "../../components/ui/input";
import { Label } from "../../components/ui/label";
import { api, apiError } from "../../lib/api";

export default function Blocks() {
  const [blocks, setBlocks] = useState([]);
  const [date, setDate] = useState("");
  const [reason, setReason] = useState("");
  const [busy, setBusy] = useState(false);

  const refresh = () => api.get("/doctor/blocks").then((r) => setBlocks(r.data));
  useEffect(() => { refresh(); }, []);

  const add = async () => {
    if (!date) return;
    setBusy(true);
    try {
      await api.post("/doctor/blocks", { date, reason: reason || null });
      toast.success("Time off added");
      setDate(""); setReason("");
      refresh();
    } catch (e) { toast.error(apiError(e, "Failed")); } finally { setBusy(false); }
  };

  const remove = async (id) => {
    try {
      await api.delete(`/doctor/blocks/${id}`);
      refresh();
    } catch (e) { toast.error(apiError(e, "Failed")); }
  };

  return (
    <div className="space-y-6 max-w-3xl" data-testid="doc-blocks">
      <div>
        <div className="text-[10px] uppercase tracking-[0.3em] text-teal-400">◖ time off</div>
        <h1 className="mt-2 text-3xl font-light tracking-tight">My time off</h1>
        <p className="text-sm text-mb-fg2 mt-1">Block ad-hoc dates. Patients won't see slots on these days.</p>
      </div>
      <div className="rounded-xl border border-mb-border bg-mb-surface p-5 grid grid-cols-1 sm:grid-cols-[180px_1fr_auto] gap-3 sm:items-end">
        <div>
          <Label className="text-xs uppercase tracking-[0.2em] text-mb-fg2">Date</Label>
          <Input type="date" value={date} onChange={(e) => setDate(e.target.value)} data-testid="block-date"
            className="mt-2 bg-mb-surface2 border-mb-border text-white h-10 rounded-lg" />
        </div>
        <div>
          <Label className="text-xs uppercase tracking-[0.2em] text-mb-fg2">Reason (optional)</Label>
          <Input value={reason} onChange={(e) => setReason(e.target.value)} data-testid="block-reason"
            className="mt-2 bg-mb-surface2 border-mb-border text-white h-10 rounded-lg" />
        </div>
        <Button onClick={add} disabled={!date || busy} data-testid="add-block"
          className="bg-teal-500 hover:bg-teal-400 text-zinc-950 rounded-lg h-10 px-4 font-medium">
          <Plus className="h-4 w-4 mr-2" /> Add
        </Button>
      </div>
      <div className="rounded-xl border border-mb-border bg-mb-surface">
        <ul className="divide-y divide-mb-border">
          {blocks.length === 0 && (
            <li className="px-6 py-10 text-sm text-mb-fg2 text-center" data-testid="blocks-empty">No blocked dates.</li>
          )}
          {blocks.map((b) => (
            <li key={b.id} className="px-5 py-3 flex items-center justify-between" data-testid={`block-row-${b.id}`}>
              <div>
                <div className="text-sm text-white">{b.date}</div>
                <div className="text-xs text-mb-fg2">{b.reason || "—"} {b.created_by === "doctor" ? "(by you)" : "(by hospital)"}</div>
              </div>
              <Button onClick={() => remove(b.id)} variant="ghost" data-testid={`remove-block-${b.id}`}
                className="hover:bg-red-500/10 text-red-400 h-9"><X className="h-4 w-4" /></Button>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}
